var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5V21.5H21.5V0.5H0.5ZM19.1667 19.1667H2.83333V2.83333H19.1667V19.1667ZM9.83333 5.16667H12.1667V7.5H9.83333V5.16667ZM5.16667 5.16667H7.5V7.5H5.16667V5.16667ZM14.5 5.16667H16.8333V7.5H14.5V5.16667ZM5.16667 9.83333H7.5V12.1667H5.16667V9.83333ZM9.83333 9.83333H12.1667V12.1667H9.83333V9.83333ZM14.5 9.83333H16.8333V12.1667H14.5V9.83333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArea);
export default __webpack_public_path__ + "static/media/icon_area.21566eb0a3792a285830697e8a6f1317.svg";
export { ForwardRef as ReactComponent };